import { IRendererConfig, ICol, IEditor, GridEvents } from "../../types";
import { InputEditor } from "./InputEditor";
import { SelectEditor } from "./SelectEditor";
import { DateEditor } from "./DateEditor";
import { CheckboxEditor } from "./CheckboxEditor";
import { ComboboxEditor } from "./ComboboxEditor";
import { TextAreaEditor } from "./TextAreaEditor";

let lastEditor = {
	cell: {
		row: null,
		col: null,
	},
	editor: null,
	gridId: null,
};

let editHandler;

export function getEditor(row: any, col: ICol, conf: IRendererConfig): IEditor {
	let type = col.type === "boolean" ? "checkbox" : conf.$editable.editorType;
	if (typeof type === "undefined") type = conf.autoHeight ? "textarea" : "input";
	if (
		lastEditor.cell.row === row.id &&
		lastEditor.cell.col === col.id &&
		lastEditor.gridId === conf.gridId &&
		conf.$editable.editor
	) {
		return lastEditor.editor;
	}

	if (type !== "checkbox") {
		lastEditor = {
			cell: {
				row: row.id,
				col: col.id,
			},
			editor: lastEditor.editor,
			gridId: conf.gridId,
		};
	}

	if (!editHandler) {
		editHandler = () => {
			lastEditor = {
				cell: {
					row: null,
					col: null,
				},
				editor: null,
				gridId: null,
			};
		};
		conf.events.on(GridEvents.afterEditEnd, editHandler);
	}

	switch (type) {
		case "input":
			return (lastEditor.editor = new InputEditor(row, col, conf));
		case "textarea":
			return (lastEditor.editor = new TextAreaEditor(row, col, conf));
		case "select":
			return (lastEditor.editor = new SelectEditor(row, col, conf));
		case "datePicker":
			return (lastEditor.editor = new DateEditor(row, col, conf));
		case "checkbox":
			return new CheckboxEditor(row, col, conf);
		case "multiselect":
		case "combobox":
			return (lastEditor.editor = new ComboboxEditor(row, col, conf));
		default:
			return (lastEditor.editor = new InputEditor(row, col, conf));
	}
}
